module.exports = __webpack_public_path__ + "img/homebut.0f174532.png";